
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4681_13992)"}},[_c('path',{attrs:{"d":"M14.312 1.418H8.466V.233a.597.597 0 00-.171-.419.58.58 0 00-.827 0 .597.597 0 00-.171.42v1.184H1.45c-.31 0-.607.125-.826.348-.22.222-.343.523-.343.838v8.888c0 .315.123.616.343.838.219.223.516.347.826.347h2.877l-1.58 2a.598.598 0 00.092.834.58.58 0 00.822-.093l2.162-2.74H9.94l2.162 2.74a.589.589 0 00.393.219.577.577 0 00.576-.303.598.598 0 00-.055-.657l-1.58-2h2.877c.31 0 .607-.124.827-.347.22-.222.342-.523.342-.838V2.604c0-.315-.123-.616-.342-.839a1.161 1.161 0 00-.827-.347z","fill":"#910000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4681_13992"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    